module.exports = __webpack_public_path__ + "static/book-cover-47296b9da5b7ddd8bd1d4711383fe4ff.webp";